import {page} from '@/shared/helpers.js';
import {computed} from 'vue';

export const top_position_from_banner = () => page?.props?.banners?.id
	? 'sticky-sidebar top-[calc(100px+94.5px)] lg:sticky overflow-y-auto lg:h-[calc(100vh-100px-94.5px)] flex flex-col justify-between'
	: 'sticky-sidebar lg:sticky top-[calc(94.5px)] overflow-y-auto lg:h-[calc(100vh-100px-94.5px)] flex flex-col justify-between';

export const top_offset = computed(() => page?.props?.banners?.id
	? 'sticky-sidebar-no-scroll top-[calc(100px+94.5px)] lg:sticky lg:h-[calc(100vh+100px-94.5px)] flex flex-col justify-between'
	: 'sticky-sidebar-no-scroll lg:sticky top-[calc(94.5px)] lg:h-[calc(100vh-100px-94.5px)] flex flex-col justify-between'
);
